import colorsActive from './menuIcons/colors_active.svg';
import colorsInactive from './menuIcons/colors_inactive.svg';
import dimensionsInactive from './menuIcons/dimensions_inactive.svg';
import roofInactive from './menuIcons/roof_inactive.svg';
import wallsInactive from './menuIcons/walls_inactive.svg';
import warehouseTypeInactive from './menuIcons/warehouseType_inactive.svg';
import doorActive from './menuIcons/door_active.svg';
import doorInactive from './menuIcons/door_inactive.svg';
import gateActive from './menuIcons/gate_active.svg';
import gateInactive from './menuIcons/gate_inactive.svg';
import lightbandActive from './menuIcons/lightband_active.svg';
import lightbandInactive from './menuIcons/lightband_inactive.svg';
import windowActive from './menuIcons/window_active.svg';
import windowInactive from './menuIcons/window_inactive.svg';
import glassElement from './menuIcons/glass_element.svg';

import door from './menuIcons/door.png';
import wall_glass from './menuIcons/wall_glass.png';
import wall_hard_plastic_white from './menuIcons/wall_hard_plastic_white.png';
import wall_pvc_transparent from './menuIcons/wall_pvc_transparent.png';
import wall_pvc_white from './menuIcons/wall_pvc_white.png';

const itemIcons = {
  tent: {
    door,
    wall_glass,
    wall_hard_plastic_white,
    wall_pvc_transparent,
    wall_pvc_white,
  },
};

export default function getMenuIcons(identifier, itemIdentifier) {
  let iconActive;
  let iconInactive;

  const itemIcon = itemIcons[itemIdentifier]?.[identifier];
  if (itemIcon) {
    return {
      iconActive: itemIcon,
      iconInactive: itemIcon,
    };
  }

  switch (identifier) {
    case 'colors':
      iconActive = colorsActive;
      iconInactive = colorsInactive;
      break;
    case 'dimensions':
      iconInactive = dimensionsInactive;
      break;
    case 'door':
      iconActive = doorActive;
      iconInactive = doorInactive;
      break;
    case 'gate':
      iconActive = gateActive;
      iconInactive = gateInactive;
      break;
    case 'roof':
      iconInactive = roofInactive;
      break;
    case 'wall_lightband':
      iconActive = lightbandActive;
      iconInactive = lightbandInactive;
      break;
    case 'walls':
      iconInactive = wallsInactive;
      break;
    case 'warehouseType':
      iconInactive = warehouseTypeInactive;
      break;
    case 'window':
      iconActive = windowActive;
      iconInactive = windowInactive;
      break;
    case 'glass_element': {
      iconActive = glassElement;
      iconInactive = glassElement;
    }
  }
  return {
    iconActive,
    iconInactive,
  };
}
